export const colors = {
  interface: {
    primary: {
      lightest: '#FFDC7A',
      lighter: '#FFD359',
      normal: '#FFCA38',
      darker: '#F5BC22',
      darkest: '#EDB211',
    },
    secondary: {
      lightest: '#7795B8',
      lighter: '#4E6F94',
      normal: '#416288',
      darker: '#314966',
      darkest: '#24374C',
    },
    layout: {
      lightest: '#FAFAFB',
      lighter: '#F4F5F6',
      normal: '#DFE3E7',
      darker: '#CCD2D8',
      darkest: '#C2C9D0',
    },
    content: {
      lightest: '#B9B9C1',
      lighter: '#93939C',
      normal: '#474752',
      darker: '#1C1C21',
      darkest: '#070708',
    },
    neutral: {
      light: '#FFFFFF',
      dark: '#000000',
    },
  },
  feedback: {
    success: {
      lightest: '#E2F1E3',
      lighter: '#C3E1C7',
      normal: '#89C58E',
      darker: '#5B9A61',
      darkest: '#3D7D43',
    },
    warning: {
      lightest: '#FCE2CC',
      lighter: '#F9C99D',
      normal: '#F59E54',
      darker: '#D47828',
      darkest: '#C36412',
    },
    error: {
      lightest: '#FDDFD8',
      lighter: '#FBC5BA',
      normal: '#F77A5F',
      darker: '#DD4C2C',
      darkest: '#CC2D0A',
    },
    information: {
      lightest: '#DFF0F1',
      lighter: '#BCE0E3',
      normal: '#8FCBCF',
      darker: '#6FB2B6',
      darkest: '#4E999D',
    },
  },
  brand: {
    green1: {
      lightest: '#D3E9D6',
      lighter: '#C3E1C7',
      normal: '#A9DBB0',
      darker: '#5B9A61',
      darkest: '#3D7D43',
    },
    orange1: {
      lightest: '#FCE2CC',
      lighter: '#F9C99D',
      normal: '#F59E54',
      darker: '#D47828',
      darkest: '#C36412',
    },
    red1: {
      lightest: '#FDDFD8',
      lighter: '#FBC5BA',
      normal: '#F77A5F',
      darker: '#DD4C2C',
      darkest: '#CC2D0A',
    },
    blue1: {
      lightest: '#DFF0F1',
      lighter: '#BCE0E3',
      normal: '#8FCBCF',
      darker: '#6FB2B6',
      darkest: '#4E999D',
    },
    purple1: {
      lightest: '#EDE7F9',
      lighter: '#DFD5F4',
      normal: '#C3B0EA',
      darker: '#9F81DE',
      darkest: '#855ED4',
    },
    green2: {
      lightest: '#D4E5DE',
      lighter: '#BAD5C9',
      normal: '#9DC3B3',
      darker: '#72A18E',
      darkest: '#4E7F6A',
    },
    orange2: {
      lightest: '#FBE6C8',
      lighter: '#F8C886',
      normal: '#F5B254',
      darker: '#D59336',
      darkest: '#A6650A',
    },
    red2: {
      lightest: '#FDDFD8',
      lighter: '#F9B38F',
      normal: '#F7925F',
      darker: '#E9824E',
      darkest: '#CC612B',
    },
    blue2: {
      lightest: '#E6EBF5',
      lighter: '#C5D1E7',
      normal: '#A9BBDC',
      darker: '#8DA5D1',
      darkest: '#7995C8',
    },
    purple2: {
      lightest: '#F5D7E7',
      lighter: '#F0BFD9',
      normal: '#E8A0C7',
      darker: '#E081B5',
      darkest: '#DB69A7',
    },
  },
} as const;
